import { jsxs, jsx } from "react/jsx-runtime";
import React from "react";
import { useConstructorContext } from "../../context/constructor.js";
import { formatConstructorItemStyle } from "./ConstructorItem.utils.js";
import styles from "./ConstructorItem.module.scss.js";
const FallbackComponent = React.Fragment;
const useFallbackContainer = () => ({});
function ConstructorItem({ item }) {
  const { widgets } = useConstructorContext();
  const widget = item.type ? widgets[item.type] : null;
  const { component: Component = FallbackComponent, useContainer = useFallbackContainer } = widget || {};
  return /* @__PURE__ */ jsxs(
    "section",
    {
      id: item.id,
      style: formatConstructorItemStyle(item),
      className: styles.constructorItem,
      "data-widget-type": item.type,
      children: [
        item.itemCSS && /* @__PURE__ */ jsx(
          "style",
          {
            dangerouslySetInnerHTML: {
              __html: `#${item.id} { ${item.itemCSS} }`.trim()
            }
          }
        ),
        /* @__PURE__ */ jsx(Component, { ...useContainer(item) })
      ]
    }
  );
}
export {
  ConstructorItem
};
